import React from 'react'
import s from './GameButton.module.scss'
import cx from 'classnames'

GameButton.defaultProps = {

}

export default function GameButton({onClick, id, className, children}) {

  return (
    <button id={id} className={cx(s.GameButton, className)} onClick={ onClick }>
      {children}
    </button>
  )
}
